"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceAdapter = void 0;
const errors_1 = require("./errors");
const types_1 = require("./types");
class BalanceAdapter {
    constructor({ api, chain, tokens }) {
        var _a, _b;
        this.chain = chain;
        this.decimals = api.registry.chainDecimals[0];
        this.ed = types_1.FN.fromInner(((_b = (_a = api.consts.balances) === null || _a === void 0 ? void 0 : _a.existentialDeposit) === null || _b === void 0 ? void 0 : _b.toString()) || "0", this.decimals);
        this.nativeToken = api.registry.chainTokens[0];
        this.tokens = tokens;
    }
    getToken(token) {
        const tokenConfig = this.tokens[token];
        if (!tokenConfig) {
            throw new errors_1.TokenConfigNotFound(token, this.chain);
        }
        return tokenConfig;
    }
}
exports.BalanceAdapter = BalanceAdapter;
